import React, { PropsWithChildren } from 'react';
import { Row, Col } from 'reactstrap';
import './index.css';

export type ItemContainerTextProps = PropsWithChildren<{
  text?: string;
  noLead?: boolean;
}>;

const ItemContainerText = ({
  text,
  children,
  noLead,
}: ItemContainerTextProps) => (
  <Row noGutters className="ic-text m-2">
    <Col>
      <span className={noLead ? '' : 'lead'}>
        {`${text} `}
        {children}
      </span>
    </Col>
  </Row>
);

export default ItemContainerText;
